<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">CONTENTS</p>
<p class="toc"><a href="#/Foreword">Foreword, by John Taliaferro</a></p>
<p class="toc"><a href="#/Author_Notes">Author’s Notes</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. 1885: Hunting and Fishing in the St. Mary’s Lakes</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. 1886: Meanwhile, Back in New York</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. 1887: Exploring the Glacier</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. 1888: Honoring Piegan Friends</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. 1889: Goat Expedition in British Columbia</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. 1890: More Mapping and Discovery</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. 1891: Yale Men Can’t Shoot</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. 1895: Agreement to Purchase Blackfeet Mountain Land</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. 1897: Over the Garden Wall</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. 1898: Who Is the Biggest Man?</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. 1901: Crown of the Continent, September</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. 1907–1910: The Legislative Process</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. 1910–1915: Park Improvements</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. 1923: Visit to the Park with Elizabeth</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. 1925: Theodore Roosevelt Medal for Distinguished Service</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. 1926: Last Visit</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. 1927–1938: Last Years</span></p>
<p class="toc1"><span href="#/Appendix" title="Link target outside of Sample">Appendix. Geological Features Named by George Bird Grinnell</span></p>
<p class="toc"><span href="#/Acknowledgements" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?14fd3941